export const IdentificationSettings = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="4" cy="4" r="3" transform="matrix(-1 0 0 1 15 12)" stroke="currentColor" stroke-width="2"/>
<path d="M6 26V24C6 22.8954 6.89543 22 8 22H14C15.1046 22 16 22.8954 16 24V26" stroke="currentColor" stroke-width="2"/>
<path d="M25 21H18" stroke="currentColor" stroke-width="2"/>
<path d="M25 25H21" stroke="currentColor" stroke-width="2"/>
<path d="M28 20V29.1429C28 29.6952 27.5523 30.1429 27 30.1429H3C2.44772 30.1429 2 29.6952 2 29.1429V8.85718C2 8.30489 2.44772 7.85718 3 7.85718H15" stroke="currentColor" stroke-width="2"/>
<path d="M24 3V6" stroke="currentColor" stroke-width="2"/>
<path d="M24 14V17" stroke="currentColor" stroke-width="2"/>
<path d="M28.9497 5.05029L26.8284 7.17161" stroke="currentColor" stroke-width="2"/>
<path d="M21.1716 12.8284L19.0502 14.9497" stroke="currentColor" stroke-width="2"/>
<path d="M31 10L28 10" stroke="currentColor" stroke-width="2"/>
<path d="M20 10L17 10" stroke="currentColor" stroke-width="2"/>
<path d="M28.9497 14.9497L26.8284 12.8284" stroke="currentColor" stroke-width="2"/>
<path d="M21.1716 7.17163L19.0502 5.05031" stroke="currentColor" stroke-width="2"/>
<circle cx="24" cy="10" r="4" stroke="currentColor" stroke-width="2"/>
</svg>`;
